import React from "react";

function DriverAndVehicleLog() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden; /* Hide all elements on the page */
            }
            #DriverAndVehicleLogForm, #DriverAndVehicleLogForm * {
              visibility: visible; /* Make only the form and its children visible */
            }
            #DriverAndVehicleLogForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            /* Hide print button during printing */
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div
        id="DriverAndVehicleLogForm"
        className="p-4 border rounded-lg bg-white shadow-md font-sans"
      >
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">
          Vehicle & Driver Log
        </h3>

        <form>
          {/* Managed By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managedBy">
              Managed By (Name):
            </label>
            <input
              type="text"
              id="managedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter manager's name"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="date">
              Date:
            </label>
            <input
              type="date"
              id="date"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Shift */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="shift">
              Shift:
            </label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">AM</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">PM</span>
              </label>
            </div>
          </div>

          {/* Time In and Time Out */}
          <div className="mb-4 flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
            <div className="w-full md:w-1/2">
              <label className="block text-lg font-medium text-gray-700" htmlFor="timeIn">
                Time In:
              </label>
              <input
                type="time"
                id="timeIn"
                className="p-3 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="w-full md:w-1/2">
              <label className="block text-lg font-medium text-gray-700" htmlFor="timeOut">
                Time Out:
              </label>
              <input
                type="time"
                id="timeOut"
                className="p-3 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Driver Name */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverName">
              Driver Name:
            </label>
            <input
              type="text"
              id="driverName"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver name"
            />
          </div>

          {/* Vehicle Registration */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="vehicleReg">
              Vehicle Registration:
            </label>
            <input
              type="text"
              id="vehicleReg"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter vehicle registration"
            />
          </div>

          {/* Signed In By and Signed Out By */}
          <div className="mb-4 flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
            <div className="w-full md:w-1/2">
              <label className="block text-lg font-medium text-gray-700" htmlFor="signedInBy">
                Signed In By:
              </label>
              <input
                type="text"
                id="signedInBy"
                className="p-3 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter name"
              />
            </div>
            <div className="w-full md:w-1/2">
              <label className="block text-lg font-medium text-gray-700" htmlFor="signedOutBy">
                Signed Out By:
              </label>
              <input
                type="text"
                id="signedOutBy"
                className="p-3 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter name"
              />
            </div>
          </div>

          {/* Notes Section */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Record any security incidents, issues, or unusual activity"
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-full md:w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default DriverAndVehicleLog;

